module.exports = __webpack_public_path__ + "img/entrePriseNews.ddb695de.jpg";